import styled from "styled-components";

export const RootContainer = styled.div`
  padding: 24px 16px;
`;

export const Container = styled.div`
  min-height: 20vh;
`;

export const ItemBox = styled.div`
  width: 100%;
  padding: 16px 0;
  margin-bottom: 16px;
  border-radius: 10px;
  border: 1px solid #e1cce0;
  background-color: #fff;
`;

export const Box = styled.div`
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoBoxWrapper = styled.div`
  flex: 0.7;
  text-align: left;
`;

export const InfoBox = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  grid-gap: 8px;
  padding-inline: 20px 8px;

  @media screen and (max-width: 365px) {
    padding-inline: 8px 5px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;
  width: 100%;
  text-align: center;

  .ant-btn-primary {
    min-width: 170px;
    height: 42px;

    :disabled {
      background-color: #fff !important;
    }
  }
`;

export const ActionLabel = styled.div`
  padding-top: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #71207c;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageBox = styled.div`
  flex: 0.3;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 40px;
  @media screen and (max-width: 350px) {
    width: 35px;
  }
  @media screen and (max-width: 310px) {
    width: 30px;
  }
`;

export const TypeText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  
  @media screen and (max-width: 310px) {
    font-size: 12px;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #73217d;
  text-align: center;
  
  @media screen and (max-width: 350px) {
    font-size: 13px;
  }
  @media screen and (max-width: 310px) {
    font-size: 12px;
  }
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  text-align: center;

  @media screen and (max-width: 350px) {
    font-size: 13px;
  }
  @media screen and (max-width: 310px) {
    font-size: 12px;
  }
`;

export const Divider = styled.div`
  width: 1px;
  border-right: 1px solid #e1cce0;
  height: 55px;
`;